<template>
  <el-steps
      ref="gjSteps"
      v-bind="$attrs"
      v-on="$listeners"
      finish-status="success"
      :class="[`gj-step--${size}`]">
    <el-step
        ref="gjStep"
        v-for="(step, index) in steps"
        :key="index"
        :title="step.title || step">
      <template v-if="step.descriptionTpl" #description>
        <slot :name="step.descriptionTpl"></slot>
      </template>
    </el-step>
  </el-steps>
</template>

<script>
  export default {
    name: "gj-steps",
    props: {
      steps: {
        type: Array,
        required: true
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'medium'].indexOf(value) !== -1
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gj-step--default /deep/ .el-step__title {
    font-size: 14px;
    line-height: 28px;
  }
  .gj-step--default /deep/ .el-step__icon {
    width: 18px;
    height: 18px;
  }
  
  .gj-step--default /deep/ .el-step.is-horizontal .el-step__line {
    top: 8px;
  }
  /deep/ .el-step__main{
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #1F6EEF;
    font-weight: 500;
  }
  /deep/ .is-wait{
    color: #666666;
  }
  // /deep/ .el-step__icon.is-text{
  //   color: #D8DADD;
  // }
</style>
